export default __webpack_public_path__ + "static/media/logomarca.6d44662b.png";